import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsTransferMoneyFeatureEnabled } from '../../../Redux/selectors';

// Resolves the fallback label color class, in precedence order:
// 1. the transfer money feature styling
// 2. the legacy textColor flag
// 3. the default card text color
const getLabelColorClass = (isTransferMoneyFeatureEnabled, textColor) => {
    if (isTransferMoneyFeatureEnabled) return 'text-[var(--input-text-title)]';
    if (textColor) return 'text-[var(--text-clr-textarea)]';
    return 'text-[var(--primary-text-cards)]';
};

const FieldLabel = ({ name, label, textColor, labelColor, required }) => {
    const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);
    const trimmedLabel = label?.trim();
    const trimmedName = name?.trim();
    const displayText = trimmedLabel || trimmedName;
    const baseColor = getLabelColorClass(isTransferMoneyFeatureEnabled, textColor);

  return (
    <label
      htmlFor={name}
          style={labelColor ? { color: labelColor } : undefined}
          className={`font-hanken-grotesk ${baseColor} uppercase lg:text-[13px] md:text-[12px] sm:text-[9px] text-[13px] font-[600] tracking-[2px] pb-2 block`}   >
          {displayText}
          {required && (
              <span className="inline-block ml-1 text-red-500">*</span>
          )}
    </label>
  );
};

export default FieldLabel;
